import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/knowledge-base')({
  component: lazyRouteComponent(() => import('./-knowledge-base.lazy'), 'default'),
});
